import React from 'react'
import { Navigate, useRoutes } from 'react-router-dom'
import Dashboard from './Dashboard/Dashboard'
import Tenants from './Tenants/Tenants'
import SingleTenant from './Tenants/SingleTenant'
import NotFound from '../components/NotFound'
import Pipeline from './Sales/Pipeline'
import LeadDetail from './Sales/LeadDetail'
import Forecast from './Forecast/Forecast'
import CreateHazardLogForm from './ClinicalRisk/Hazards/CreateHazard'
import ViewHazardLog from './ClinicalRisk/Hazards/ViewHazardLog'
import Hazards from './ClinicalRisk/Hazards/Hazards'
import SafetyIncidents from './ClinicalRisk/SafetyIncidents/SafetyIncidents'
import SafetyIncidentDetail from './ClinicalRisk/SafetyIncidents/SafetyIncidentDetail'
import NewSafetyIncident from './ClinicalRisk/SafetyIncidents/NewSafetyIncident'
import Maintenance from './Dashboard/Maintenance'
import ReferralCodes from './ReferralCodes/ReferralCodes'
import SearchUsers from './Users/SearchUsers'
import Campaigns from './Campaigns/Campaigns'
import CampaignDetail from './Campaigns/CampaignDetail'
import DemoUsers from './DemoUsers/DemoUsers'
import TestAccounts from './TestAccounts/TestAccounts'
import CourseVersions from './Training/CourseVersions'
import FeedbackReport from './Training/FeedbackReport'
import OrganisationLinks from './Training/OrganisationLinks'

const AdminCRMRoutes = () =>
  useRoutes([
    { path: '*', element: <NotFound returnUrl="/" /> },
    { path: '/', element: <Dashboard /> },
    { path: '/tenants', element: <Tenants /> },
    {
      path: '/trial-tenants',
      element: <Navigate to="/tenants?filter=notSubscribed" replace />,
    },
    { path: '/tenants/:tenantID', element: <SingleTenant /> },
    { path: '/users', element: <SearchUsers /> },
    { path: '/sales', element: <Pipeline /> },
    {
      path: '/sales/list',
      element: <Navigate to="/sales?view=list" replace />,
    },
    { path: '/sales/new', element: <Pipeline openNew /> },
    { path: '/sales/:id', element: <LeadDetail /> },
    { path: '/forecast', element: <Forecast /> },
    { path: '/maintenance', element: <Maintenance /> },
    { path: '/clinical-risk', element: <Hazards register="Clinical" /> },
    {
      path: '/clinical-risk/codebase',
      element: <Hazards register="Codebase" />,
    },
    { path: '/clinical-risk/new', element: <CreateHazardLogForm /> },
    { path: '/clinical-risk/:hazardID', element: <ViewHazardLog /> },
    { path: '/safety-incidents', element: <SafetyIncidents /> },
    { path: '/safety-incidents/new', element: <NewSafetyIncident /> },
    { path: '/safety-incidents/:id', element: <SafetyIncidentDetail /> },
    { path: '/referral-codes', element: <ReferralCodes /> },
    { path: '/campaigns', element: <Campaigns /> },
    { path: '/campaigns/:campaignID', element: <CampaignDetail /> },
    { path: '/demo-users', element: <DemoUsers /> },
    { path: '/test-accounts', element: <TestAccounts /> },
    { path: '/training/courses', element: <CourseVersions /> },
    { path: '/training/links', element: <OrganisationLinks /> },
    { path: '/training/feedback', element: <FeedbackReport /> },
  ])

export default AdminCRMRoutes
